/**
 * @description Component-TradePositions
 */
import './index.less';

import Card from '@/components/Card';
import { useIsChosenOrder } from '@/features/trade/hooks';
import { useStaticPinObserver } from '@/hooks/useStickyPin';
import classNames from 'classnames';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Checkbox from '@/components/Checkbox';
import { useTradeStore } from '@/features/trade/store';
import EarnLiquidities from '@/pages/earn/EarnLiquidities';
import AccountHistory from '@/pages/portfolio/AccountHistory';
import TradePositionTable from '../TradePositionTable';
import TradeOpenOrders from './TradeOpenOrders';
import TradePortfolioTabs, { TabKeys } from './TradePortfolioTabs';
// import Transfers from './Transfers';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  showHideOthers?: boolean;
}

const TradePortfolio: FC<IPropTypes> = function ({ className, showHideOthers = true }) {
  const { t } = useTranslation();
  const location = useLocation();
  const isChosenOrder = useIsChosenOrder();
  const tabsHeaderStickyRef = useRef<HTMLDivElement>(null);
  const [activeTab, setActiveTab] = useState<TabKeys>(TabKeys.POSITIONS);
  const { hideOtherPair, setHideOtherPair } = useTradeStore();

  useStaticPinObserver(tabsHeaderStickyRef);

  const handleTabClick = (key: string) => {
    setActiveTab(key as TabKeys);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case TabKeys.POSITIONS:
        return (
          <>
            <TradePositionTable />
          </>
        );
      case TabKeys.OPEN_ORDERS:
        return <TradeOpenOrders isEditing={isChosenOrder} />;
      case TabKeys.LIQUIDITY:
        return <EarnLiquidities />;
      case TabKeys.HISTORY:
        return <AccountHistory isTradePage={true} />;
      default:
        return null;
    }
  };
  useEffect(() => {
    const { tab } = location.state || {};
    if (tab) {
      setActiveTab(tab as TabKeys);
    }
  }, [location.state]);

  useEffect(() => {
    if (!showHideOthers) {
      setHideOtherPair(false);
    }
  }, [showHideOthers]);

  return (
    <Card className={classNames(className, 'syn-trade-portfolio')}>
      <div className="syn-trade-portfolio-content">
        <div className="syn-trade-portfolio-content-header">
          <TradePortfolioTabs activeTab={activeTab} onTabClick={handleTabClick} />
          <div className="syn-trade-portfolio-content-header-right">
            {showHideOthers && (
              <Checkbox checked={hideOtherPair} onChange={(e) => setHideOtherPair(e.target.checked)}>
                {t('common.tradePortfolio.hideOtherP')}
              </Checkbox>
            )}
          </div>
        </div>
        <div className="syn-trade-portfolio-content-tab-content">{renderTabContent()}</div>
      </div>
    </Card>
  );
};

export default TradePortfolio;
